const GET_CART = 'GET_CART';
const CLEAR_CART = 'CLEAR_CART';

export default {
  GET_CART,
  CLEAR_CART,
};
